import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  glowColor?: 'cyan' | 'red' | 'none';
}
export function Card({
  children,
  className = '',
  hoverEffect = true,
  glowColor = 'none'
}: CardProps) {
  const glowStyles = {
    cyan: 'hover:border-[#00d9ff]/50 hover:shadow-[0_0_20px_rgba(0,217,255,0.15)]',
    red: 'hover:border-[#ff3366]/50 hover:shadow-[0_0_20px_rgba(255,51,102,0.15)]',
    none: ''
  };
  return <motion.div whileHover={hoverEffect ? {
    y: -5
  } : {}} transition={{
    duration: 0.3
  }} className={`bg-glass rounded-xl p-6 md:p-8 transition-all duration-300 ${hoverEffect ? glowStyles[glowColor] : ''} ${className}`} data-id="element-294">
      {children}
    </motion.div>;
}